import { useTranslations } from "next-intl";
import { css } from "styled-system/css";

import { FullScreenError } from "@/components/full-screen-error";

export function MaintenanceModeScreen({ message }: { message?: string }) {
  const t = useTranslations("errorScreens");

  return (
    <div className={css({ bg: "background.canvas", h: "[100vh]", w: "[100vw]" })}>
      <FullScreenError
        heading={t("maintenanceHeading")}
        description={message ?? t("maintenanceDescription")}
      />
    </div>
  );
}

export function TradeMaintenanceModeScreen() {
  const t = useTranslations("errorScreens");

  return (
    <div className={css({ position: "fixed", inset: "0", zIndex: "[4]", bg: "background.canvas" })}>
      <FullScreenError
        heading={t("maintenanceHeading")}
        description={t("maintenanceDescription")}
      />
    </div>
  );
}
